import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: '/publication',
    name: 'publication',
    component: () => import("../views/PublicationView.vue"),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import("../views/DemoView.vue"),
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import("../views/privacy-policy.vue"),
  },
  {
    path: '/terms-of-service',
    name: 'terms-use',
    component: () => import("../views/terms-use.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
